import { FC } from 'react';
import { MessageContent } from './MessageContent';
import { PaulinaContextValue } from './PaulinaProvider';

/**
 * Cuerpo del chat (lista de mensajes + input) compartido por el panel desktop
 * (PaulinaPanel) y el bottom-sheet móvil (PaulinaSheet). Es presentacional: recibe
 * el estado del chat por props desde el contexto para no duplicar el render de
 * mensajes/input en cada superficie.
 */

type ConversationProps = Pick<
  PaulinaContextValue,
  'turns' | 'input' | 'setInput' | 'busy' | 'error' | 'bottomRef' | 'goTo' | 'send'
>;

export const PaulinaConversation: FC<ConversationProps> = ({
  turns,
  input,
  setInput,
  busy,
  error,
  bottomRef,
  goTo,
  send,
}) => (
  <>
    <div className="flex-1 space-y-2 overflow-y-auto p-3 text-sm">
      {turns.length === 0 && (
        <p className="mt-4 text-center text-[#64748b]">
          ¡Hola! Soy Paulina. Pregúntame cómo usar Plick o sobre tu operación.
        </p>
      )}
      {turns.map((t, i) => (
        <div
          key={i}
          className={
            t.role === 'user'
              ? 'ml-8 rounded-lg rounded-br-none bg-[#253746] px-3 py-2 text-[#ffffff]'
              : 'mr-8 rounded-lg rounded-bl-none bg-[#f1f4f6] px-3 py-2 text-[#253746]'
          }
        >
          <MessageContent text={t.content} onNavigate={goTo} />
        </div>
      ))}
      {busy && (
        <div className="mr-8 rounded-lg bg-[#f1f4f6] px-3 py-2 text-[#253746]">
          <span className="animate-pulse">Paulina está escribiendo…</span>
        </div>
      )}
      {error && <p className="text-xs text-[#dc2626]">{error}</p>}
      <div ref={bottomRef} />
    </div>

    <form onSubmit={send} className="flex gap-2 border-t border-[#e2e8f0] p-2">
      <input
        type="text"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        placeholder="Escribe tu pregunta…"
        className="flex-1 rounded-lg border border-[#e2e8f0] bg-[#ffffff] px-3 py-2 text-sm text-[#253746] outline-none"
        disabled={busy}
      />
      <button
        type="submit"
        disabled={busy || !input.trim()}
        className="rounded-lg bg-[#253746] px-4 py-2 text-sm font-semibold text-[#ffffff] disabled:opacity-50"
      >
        Enviar
      </button>
    </form>
  </>
);
